export const ROUTES = {
  SUPPLIERS: '/suppliers',
  SHOPS: '/shops',
  AFFILIATE: '/admin/affiliate-configuration',
  ADD_AFFILIATE: '/admin/affiliate-configuration/add',
  EDIT_AFFILIATE: '/admin/affiliate-configuration/edit/:id',
  HTTP_4XX_ERROR: '/error',
  HTTP_5XX_ERROR: '/error-5xx',
}
